import DataService from "./DataService";

const getAuth = (credential) => {
  if (!credential) {
    return { headers: {} };
  }

  return {
    headers: {
      Authorization: credential.startsWith("Bearer ")
        ? credential
        : "Bearer " + credential,
    },
  };
};

const formatWords = (words) => {
  if (!words) {
    return [];
  }

  if (Array.isArray(words)) {
    return words;
  }

  return words
    .split(",")
    .map(function (s) {
      return s.trim();
    })
    .filter(function (s) {
      return s !== "";
    });
};

const ExerciseService = {
  async list(type, credential, isAdmin) {
    try {
      const config = getAuth(credential);
      let response;
      if (isAdmin) {
        response = await DataService.listExercisesAdmin(type, config);
      } else {
        response = await DataService.listExercisesUser(type, config);
      }
      return response.data;
    } catch (error) {
      console.error("Erro ao listar exercícios:", error);
      return [];
    }
  },

  async save(exercise, credential) {
    try {
      const config = getAuth(credential);

      const payload = {
        ...exercise,
        acceptedWords: formatWords(exercise.acceptedWords),
        rejectedWords: formatWords(exercise.rejectedWords),
      };

      if (payload.id) {
        return await DataService.updateExercise(payload.id, payload, config);
      }

      return await DataService.saveExercise(payload, config);
    } catch (error) {
      console.error("Erro ao salvar exercício:", error);
      throw error;
    }
  },

  async remove(id, credential) {
    try {
      return await DataService.deleteExercise(id, getAuth(credential));
    } catch (error) {
      console.error("Erro ao deletar exercício:", error);
      throw error;
    }
  },

  async validate(id, input, credential) {
    try {
      const authConfig = getAuth(credential);
      let normalizedInput = input;
      if (input && typeof input === "object") {
        normalizedInput = JSON.stringify(input);
      }
      const config = {
        headers: {
          ...authConfig.headers,
          "Content-Type": "text/plain; charset=UTF-8",
        },
      };
      const response = await DataService.validateExercise(
        id,
        normalizedInput,
        config
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao validar exercício:", error);
      throw error;
    }
  },
};
export default ExerciseService;
